import React, { useEffect } from "react";

import LeaveDetails from "../../components/admin/Leave-Details";




const LeaveDetailsPage = () => {

    useEffect(() => {
        document.body.id = "leavedetailsPage-002";
      }, []);

  return (
    <div>
  <LeaveDetails />
    </div>
  );
};

export default LeaveDetailsPage;
